// @core/api/endpoints/authn/create_oauth2_client.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateOAuth2ClientRequest,
  CreateOAuth2ClientResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Create OAuth2 client
 * Registers a new OAuth2 client application with specified redirect URIs, grant types, and scopes. Returns the client credentials including the secret which is only shown once.
 */
export async function CreateOAuth2Client(
  data: CreateOAuth2ClientRequest,
  options?: RequestOptions
): Promise<CreateOAuth2ClientResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/clients`;
  const requestOptions = options;
  return client.post<CreateOAuth2ClientResponse>(requestPath, data, requestOptions);
}
